import { fromJS } from 'immutable';
import { OPTIONS_LOADED, LOADING_DATA, LOADING_ERROR, CHANGE_DEFAULT_SHAPE } from 'domain/Options/constants';

function optionsLoaded(state, { options, language, country }) {
  return state
    .set('options', fromJS(options))
    .set('loaded', fromJS({ language, country }))
    .set('loading', false);
}


function changeDefaultShape(state, shapeId, measurements) {
  const shapeIndex = state.getIn(['options', 'shapes']).findIndex((s) => s.get('id') === shapeId);
  const newDimensions = state.getIn(['options', 'shapes', shapeIndex, 'dimensions']).map((dim, key) => measurements[key] ? dim.set('defaultValue', measurements[key]) : dim);

  return state.setIn(['options', 'shapes', shapeIndex, 'dimensions'], newDimensions);
}

function optionsReducer(state, action) {
  switch (action.type) {
    case OPTIONS_LOADED:
      return optionsLoaded(state, action);
    case CHANGE_DEFAULT_SHAPE:
      return changeDefaultShape(state, action.shapeId, action.measurements);
    case LOADING_DATA:
      return state.set('loading', action.loading);
    case LOADING_ERROR:
      return state.set('error', action.error);
    default:
      return state;
  }
}

export default optionsReducer;
